/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.marketplace.quality.rpc.SelfServeRpc
 */

/**
 * Record for com.hubspot.chirp.core.CausalChainLink
 */

/**
 * Record for com.hubspot.chirp.core.ChirpMethodCoordinates
 */

export const BooleanFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.BooleanFilterQuery';
export const ExistsFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.ExistsFilterQuery';
export const FloatFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.FloatFilterQuery';
export const LongFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.LongFilterQuery';
export const StringFilterQueryTypename = 'com.hubspot.marketplace.search.models.filters.StringFilterQuery';
export const getSearchRequestForCollectionRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.SelfServeRpc',
  rpcName: 'getSearchRequestForCollection',
  auth: 'app',
  fingerprint: 'Wo7LA-eDawR3QlTturoQCJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getAllPublishedCollectionsRpc = {
  serviceName: 'com.hubspot.marketplace.quality.rpc.SelfServeRpc',
  rpcName: 'getAllPublishedCollections',
  auth: 'app',
  fingerprint: 'AAAAAAAAAAAGFx25esjAAZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};